import { useState, useEffect } from 'react';

const useApi = () => {
  const [carWashes, setCarWashes] = useState([]);
  const [membershipPlans, setMembershipPlans] = useState([]);
  const [loading, setLoading] = useState(true);

  const staticPlans = [
    { id: 1, name: 'Trial User', price: '299,00', number_of_washes: 3, number_of_tokens_per_wash: 3 },
    { id: 2, name: 'Light User', price: '699,00', number_of_washes: 7, number_of_tokens_per_wash: 3 },
    { id: 3, name: 'Occasional User', price: '899,00', number_of_washes: 10, number_of_tokens_per_wash: 4 },
    { id: 4, name: 'Regular User', price: '1599,00', number_of_washes: 18, number_of_tokens_per_wash: 5 },
    { id: 5, name: 'Frequent User', price: '1999,00', number_of_washes: 23, number_of_tokens_per_wash: 5 },
    { id: 6, name: 'Premium User', price: '2699,00', number_of_washes: 32, number_of_tokens_per_wash: 6 },
    { id: 7, name: 'Premium + User', price: '3299,00', number_of_washes: 40, number_of_tokens_per_wash: 7 },
    { id: 8, name: 'Ultimate User', price: '3999,00', number_of_washes: 50, number_of_tokens_per_wash: 7 }
  ];

  const staticCarWashes = [
  {
    id: 1,
    name: 'Mlaz',
    city: 'Pančevo',
    comingSoon: false,
    township: '',
    address: 'Cara Dušana 51, Pančevo',
    working_time: '00:00 - 23:59',
    number_of_boxes: 8,
    number_of_vacuums: 2,
    active_foam: true,
    tire_shine: true,
    car_fragrance: true,
    lat: 44.866042958421666,
    lng: 20.65165073953361,
    image: '/images/car_washes/mlaz.jpg'
  },
  {
    id: 2,
    name: 'Tefik Medina',
    city: 'Pančevo',
    comingSoon: false,
    township: '',
    address: 'Svetog Save 74, Pančevo',
    working_time: '00:00 - 23:59',
    number_of_boxes: 4,
    number_of_vacuums: 2,
    active_foam: true,
    tire_shine: true,
    car_fragrance: true,
    lat: 44.87858457623051,
    lng: 20.639276619882644,
    image: '/images/car_washes/tefik_medina.jpeg'
  },
  {
    id: 3,
    name: 'Spas',
    city: 'Čačak',
    comingSoon: false,
    township: '',
    address: 'Vapa Bb, Čačak',
    working_time: '00:00 - 23:59',
    number_of_boxes: 4,
    number_of_vacuums: 2,
    active_foam: true,
    tire_shine: true,
    car_fragrance: true,
    lat: 43.845255424684744,
    lng: 20.423709499999998,
    image: '/images/car_washes/spas.jpeg'
  },
  {
    id: 4,
    name: 'Smart Wash Kvartet 021',
    city: 'Novi Sad',
    comingSoon: false,
    township: '',
    address: 'Temerinski put 55a, Novi Sad',
    working_time: '00:00 - 23:59',
    number_of_boxes: 4,
    number_of_vacuums: 2,
    active_foam: true,
    tire_shine: true,
    car_fragrance: true,
    lat: 45.29093833036353,
    lng: 19.830386171164477,
    image: '/images/car_washes/smart_wash.jpeg'
  },
  {
    id: 5,
    name: 'Solid cars servis',
    city: 'Beograd',
    comingSoon: true,
    township: 'Rakovica',
    address: 'Slavka Miljkovica 81, Resnik',
    working_time: '00:00 - 23:59',
    number_of_boxes: 1,
    number_of_vacuums: 4,
    active_foam: true,
    tire_shine: true,
    car_fragrance: true,
    lat: 44.7170462311939,
    lng: 20.4654036,
    image: '/images/car_washes/coming_soon.jpg'
  },
  {
    id: 6,
    name: 'RS Car Wash SelfService',
    city: 'Beograd',
    comingSoon: true,
    township: 'Barajevo',
    address: 'Trg palih boraca i žrtava fašističkog terora 17, Barajevo',
    working_time: '00:00 - 23:59',
    number_of_boxes: 1,
    number_of_vacuums: 4,
    active_foam: true,
    tire_shine: true,
    car_fragrance: true,
    lat: 44.5936912809709,
    lng: 20.30906834232895,
    image: '/images/car_washes/coming_soon.jpg'
  },
  {
    id: 7,
    name: 'Gulan MD',
    city: 'Kovin',
    comingSoon: true,
    township: '',
    address: 'Cara Lazara 214, Kovin',
    working_time: '00:00 - 23:59',
    number_of_boxes: 1,
    number_of_vacuums: 4,
    active_foam: true,
    tire_shine: true,
    car_fragrance: true,
    lat: 44.75431290103658,
    lng: 20.982234999999996,
    image: '/images/car_washes/coming_soon.jpg'
  }
];

  useEffect(() => {
    const fetchData = () => {
      const timer = setTimeout(() => {
        setMembershipPlans(staticPlans);
        setCarWashes(staticCarWashes);
        setLoading(false);
      }, 800);
      return () => clearTimeout(timer);
    };
    fetchData();
  }, []);

  return { carWashes, membershipPlans, loading };
};

export default useApi;